module.exports = __webpack_public_path__ + "img/avatar_prego.ece8de73.svg";